import { parseIntOrNaN } from '@office-start/config-query-wrapper-service';
export function resolveAppGalleryConfig(_a) {
    var _b, _c, _d, _e;
    var featureGates = _a.featureGates, featureSettings = _a.featureSettings;
    var appGallerySettings = featureSettings.appGallery;
    // FeatureGates parsing
    var ecsAppGalleryUpdatesEnabled = (_c = (_b = featureGates.ecsAppGalleryUpdatesGates) === null || _b === void 0 ? void 0 : _b.ecsAppGalleryUpdatesEnabled) !== null && _c !== void 0 ? _c : false;
    // FeatureSettings parsing
    var numberOfBusinessApps = parseIntOrNaN((_d = appGallerySettings === null || appGallerySettings === void 0 ? void 0 : appGallerySettings.numberOfBusinessApps) !== null && _d !== void 0 ? _d : '0');
    var myApplicationsUrl = (_e = appGallerySettings === null || appGallerySettings === void 0 ? void 0 : appGallerySettings.myApplicationsUrl) !== null && _e !== void 0 ? _e : '';
    var learnMoreLinks = {};
    for (var key in appGallerySettings) {
        if (key.startsWith('learnMoreLink')) {
            var learnMoreLinkKey = key.charAt(0).toUpperCase() + key.slice(1);
            learnMoreLinks[learnMoreLinkKey] = appGallerySettings[key];
        }
    }
    return {
        numberOfBusinessApps: numberOfBusinessApps,
        learnMoreLinks: learnMoreLinks,
        myApplicationsUrl: myApplicationsUrl,
        ecsAppGalleryUpdatesEnabled: ecsAppGalleryUpdatesEnabled,
    };
}
//# sourceMappingURL=resolveAppGalleryConfig.js.map